import { ActionTree } from "vuex";
import { RootState } from "@/types";
import { ILoginRequest, LoginState } from "@/types/login";
import { IUser } from "@/types/user";
import axios from "axios";

export const actions: ActionTree<LoginState, RootState> = {
  async login({ commit, dispatch }, request: ILoginRequest) {
    try {
      const response = await axios.post<{ email: string }>("/token", request);
      await dispatch("auth/authorize", response.data, { root: true });
      commit("error/resetError", null, { root: true });

      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }

      return false;
    }
  },
  async signup({ commit }, request: ILoginRequest) {
    try {
      await axios.post<{ user: IUser }>("/signup", request);

      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }

      return false;
    }
  },
  async register(
    { commit },
    request: { token: string; password: string; name: string }
  ) {
    try {
      const response = await axios.post<{ user: IUser }>("/register", request);

      return response.data.user;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }

      return false;
    }
  },
  async resetCheck({ commit }, request: ILoginRequest) {
    try {
      await axios.post<{ user: IUser }>("/password/email", request);

      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }

      return false;
    }
  },
  async reset({ commit }, request: ILoginRequest) {
    try {
      await axios.post<{ user: IUser }>("/password/reset", request);

      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }

      return false;
    }
  }
};

export default actions;
